import React from 'react'

interface CopyIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const CopyIcon: React.FC<CopyIconProps> = ({
  color = '#000',
  gradient,
  width = 20,
  height = 24,
  alt = 'Copy icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 20 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M13 1.25H2a.75.75 0 00-.75.75v15c0 .414.336.75.75.75h3V7a2 2 0 012-2h6.75V2a.75.75 0 00-.75-.75zM15 5h3a2 2 0 012 2v15a2 2 0 01-2 2H7a2 2 0 01-2-2v-3H2a2 2 0 01-2-2V2a2 2 0 012-2h11a2 2 0 012 2v3zM7 6.25h11a.75.75 0 01.75.75v15a.75.75 0 01-.75.75H7a.75.75 0 01-.75-.75V7A.75.75 0 017 6.25z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default CopyIcon
